<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <template v-else>
            <b-card>
                <h5 class="mb-0">
                    <i class="fa fa-fw fa-info-circle mr-2" />Detail Retur Marketplace
                </h5>
                <hr />
                <b-row>
                    <b-col md="6">
                        No. Faktur Retur:
                        <strong>{{ data.no_faktur }}</strong><br />
                        No. Faktur Invoice:
                        <strong>{{ data.invoice_no_faktur }}</strong><br />
                        No. Ref Marketplace:
                        <strong>{{ data.mp_no_ref || "-" }}</strong><br />
                        Divisi:
                        <strong>{{ data.invoice_division }}</strong><br />
                        Total Refund:
                        <strong>Rp. {{ $helper.formatThousand(data.refund_amount) }}</strong><br />
                        Total Biaya:
                        <strong>Rp. {{ $helper.formatThousand(data.total_fee) }}</strong><br />
                        Alasan:
                        <strong>{{ data.reason || "-" }}</strong><br />
                        Dibuat oleh:
                        <strong>{{ data.created_by }}</strong><br />
                        Dibuat pada:
                        <strong>
                            {{ $helper.parseDate(data.created_at) }},
                            {{ $helper.parseHourMinute(data.created_at) }}
                        </strong>
                    </b-col>
                    <b-col md="6">
                        <div v-if="data.media && data.media.length > 0">
                            <strong>Media:</strong>
                            <div class="d-flex flex-wrap mt-2">
                                <div
                                    v-for="(m, idx) in data.media"
                                    :key="idx"
                                    class="mr-2 mb-2"
                                >
                                    <a :href="m.url" target="_blank">
                                        <img
                                            v-if="m.type === 'image'"
                                            :src="m.url"
                                            class="img-thumbnail"
                                            style="max-width: 150px; max-height: 150px; object-fit: cover;"
                                        />
                                        <span v-else>
                                            <i class="fa fa-file mr-1" />{{ m.mime }}
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-card>

            <b-card class="mt-3" v-if="data.fees && data.fees.length > 0">
                <h5 class="mb-0">
                    <i class="fa fa-fw fa-money mr-2" />Biaya
                </h5>
                <hr />
                <b-table
                    bordered
                    hover
                    show-empty
                    :items="data.fees"
                    :fields="feeFields"
                    responsive
                >
                    <template v-slot:empty>
                        Tidak ada data biaya.
                    </template>
                    <template v-slot:cell(amount)="row">
                        Rp. {{ $helper.formatThousand(row.item.amount) }}
                    </template>
                </b-table>
            </b-card>

            <b-card class="mt-3">
                <h5 class="mb-0">
                    <i class="fa fa-fw fa-cubes mr-2" />Barang Retur
                </h5>
                <hr />
                <b-table
                    bordered
                    hover
                    show-empty
                    :items="data.items"
                    :fields="itemFields"
                    responsive
                >
                    <template v-slot:empty>
                        Tidak ada data barang.
                    </template>
                    <template v-slot:cell(item_name)="row">
                        {{ row.item.item_type }}
                        <div class="small text-muted">
                            {{ row.item.item_kind }} - {{ row.item.item_brand }}
                        </div>
                    </template>
                    <template v-slot:cell(sale_detail_subtotal)="row">
                        Rp. {{ $helper.formatThousand(row.item.sale_detail_subtotal) }}
                    </template>
                    <template v-slot:cell(fee)="row">
                        Rp.
                        {{ $helper.formatThousand(row.item.fee) }}
                    </template>
                </b-table>
            </b-card>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,

            data: {
                items: [],
                fees: [],
                media: []
            },

            feeFields: [
                { key: "name", label: "Nama Biaya" },
                { key: "amount", label: "Jumlah" }
            ],

            itemFields: [
                { key: "item_no_faktur", label: "No. Faktur Barang" },
                { key: "item_name", label: "Barang" },
                { key: "sale_detail_subtotal", label: "Subtotal" },
                { key: "fee", label: "Biaya Marketplace" },
            ]
        };
    },

    methods: {
        init() {
            this.initStatus = 0;

            this.$axios
                .get("marketplace-returns/" + this.$route.params.id)
                .then(res => {
                    this.data = res.data.data;
                    this.initStatus = 1;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.initStatus = -1;
                });
        }
    },

    created() {
        this.init();
    }
};
</script>
